<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
	<c-card color="#85afff">
		<h4 slot="title">
			<v-icon>mdi-ruler</v-icon>
			{{ $t("pages.measurementForm.measurement") }}
		</h4>
		<v-btn v-if="!canSave" icon slot="bar-actions" @click="$emit('remove',measurement)">
			<v-icon>delete</v-icon>
		</v-btn>
		<cols-row v-if="canSave" md="12">
			<h3 style="color: red">{{ $t("pages.measurementForm.accepationForMsrmnt") }}</h3>
			<v-radio-group v-model="measurement.accepted_by" row>
				<template v-slot:label>
					<div><strong>{{ $t("acceptedBy.accepted") }}</strong></div>
				</template>
				<v-radio :label="this.$t('acceptedBy.customer')" value="customer"></v-radio>
				<v-radio :label="this.$t('acceptedBy.company')" value="company"></v-radio>
			</v-radio-group>
			<!--			<another-description-select v-model="measurement.areas" v-if="canSave"/>-->
		</cols-row>
		<cols-row md="12">
			<area-select md="6" v-model="measurement.areas" :canSave="canSave"/>
			<smart-input rows="3" md="6" :textarea="true" :label="$t('pages.orderTable.note')"
				v-model="measurement.note"></smart-input>
		</cols-row>
		<h4>{{ $t("pages.measurmentArea.GetAttenion") }}</h4>
		<cols-row v-if="isCloset">
			<smart-input md="3" :label="$t('closet.name')" v-model="measurement.closet_name"></smart-input>
			<smart-input md="3" :label="$t('closet.room')" v-model="measurement.room"></smart-input>
			<smart-input md="3" :label="$t('closet.size')" v-model="measurement.size"></smart-input>
			<smart-input md="3" :label="$t('closet.door_size')" v-model="measurement.door_size"></smart-input>
		</cols-row>
		<cols-row style="align-content:right;" v-if="!isCloset && !canSave">
			<smart-input md="6" type="checkbox" :label="$t('pages.measurementForm.checkPlaster.yes')"
				v-model="measurement.has_plaster"></smart-input>
			<smart-input style="-webkit-text-fill-color: red;" md="6" type="checkbox"
				:label="$t('pages.measurementForm.checkPlaster.ifNot')"
				v-model="measurement.confirm_plaster"></smart-input>
			<smart-input md="6" type="checkbox" :label="$t('pages.measurementForm.checkFlooring')"
				v-model="measurement.has_floor"></smart-input>
			<smart-input style="-webkit-text-fill-color: red;" md="6" type="checkbox"
				:label="$t('pages.measurementForm.checkPlaster.ifNot')"
				v-model="measurement.confirm_floor"></smart-input>
			<smart-input md="6" type="checkbox" :label="$t('pages.measurementForm.checkElecticity')"
				v-model="measurement.has_electric"></smart-input>
			<smart-input style="-webkit-text-fill-color: red;" md="6" type="checkbox"
				:label="$t('pages.measurementForm.checkPlaster.ifNot')"
				v-model="measurement.confirm_electric"></smart-input>
		</cols-row>
		<c-col>
			<drag-and-drop :key="measurement.id" :files="measurement.files"
				:inputId="measurement.id"  :removedFiles="removedFiles" :name="`files-${measurement.id}[]` "></drag-and-drop>
		</c-col>
		<c-col v-if="canSave">
			<v-btn class="primary mx-auto" @click="saveNewMeasurement">{{ $t("attributes.save") }}</v-btn>
		</c-col>
	</c-card>
</template>


<script>
	import CCard from "src/scaffoldings/cCard";
	import {types} from "src/store/modules/Measurement.module";
	import AreaSelect from "src/view/measurements/AreaSelect";
	import DragAndDrop from "src/components/DragNDrop";

	export default {
		props: {
			measurement: Object,
			removedFiles: Array,
			canSave: {default: false, type: Boolean}
		},
		name: "measurement-form",
		components: {DragAndDrop, AreaSelect, CCard},
		data() {
			return {};
		},
		computed: {
			isCloset() {
				let areas = this.measurement.areas || "";
				return areas.includes(this.$t("pages.measurmentArea.Cabinet")) ||
					areas === this.$t("pages.measurmentArea.wall");
			}
		},
		methods: {
			saveNewMeasurement() {
				if (!this.measurement.areas) {
					swal.fire({
						icon: "error",
						title: this.$t("dialog.error.title"),
						text: this.$t("dialog.error.addArea")
					});
					return;
				}

				if (!this.measurement.accepted_by) {
					swal.fire({
						icon: "error",
						title: this.$t("dialog.error.title"),
						text: this.$t("acceptedBy.empty")
					});
					return;
				}

				this.$store.dispatch(types.SAVE, this.measurement);
				this.$emit("closeDialog");
			}
		},
		created() {

		}
	};
</script>

<style scoped>


</style>
